module.exports = __webpack_public_path__ + "static/media/back5.21fd4ab7.jpg";